import { storageServerPath } from "@/utils/server/api";

export interface PostData {
  id: number;
  title: string;
  created_at: string;
  image: string;
  link: string;
  title_en?: string;
}

export default function PronouncementCard({ data }: { data: PostData }) {
  const lng = localStorage.getItem("language");

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const months = [
      "janeiro",
      "fevereiro",
      "março",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro",
    ];
    const months_en = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const day = date.getDate();
    const month =
      lng === "en" ? months_en[date.getMonth()] : months[date.getMonth()];
    const year = date.getFullYear();
    return lng === "en"
      ? `${month} ${day}, ${year}`
      : `${day} de ${month} de ${year}`;
  };

  return (
    <div className="bg-white rounded-xl shadow-md flex flex-col h-full w-[300px]">
      <div className="p-4 flex flex-col justify-between flex-grow">
        <h3 className="text-gray-800 font-semibold !text-2xl mb-2">
          <a href={data.link} target="_blank" rel="noreferrer">
            {lng === "en" ? data.title_en : data.title}
          </a>
        </h3>
        <p className="text-gray-500 text-sm">{formatDate(data.created_at)}</p>
      </div>
    </div>
  );
}
